import axios from "axios";

axios.defaults.withCredentials = true;

const readAxiosInstance = axios.create({
  //baseURL: "http://localhost:3309/api/",//dev
  baseURL: "https://db.mimikwasisi.com/api/",//prod
});

const writeAxiosInstance = axios.create({
  //baseURL: "http://localhost:3309/api/",//dev
  baseURL: "https://db.mimikwasisi.com/api/",//prod
});

const axiosInstances = {
  read: readAxiosInstance,
  write: writeAxiosInstance,
};

export default axiosInstances;